<template>
  <lf-content-loader
    :is-loading="runScorecardIds.includes(model.id)"
    data-cy="scorecard-id-skeleton"
  >
    <click-to-copy-id-column
      :model-value="model.id"
      :model="model"
      :value="String(model.id).substring(0, 5)"
    />
  </lf-content-loader>
</template>

<script setup lang="ts">
import { useScorecardsBase } from "@/hooks/scorecards";

import ClickToCopyIdColumn from "@/components/ui/ClickToCopyIdColumn.vue";
import LfContentLoader from "@/components/ui/LfContentLoader.vue";

import type { IScorecard } from "@/models/scorecards";

const { runScorecardIds } = useScorecardsBase();

defineProps<{
  model: IScorecard;
}>();
</script>
